import type { DriveLifecycle } from './types';

/** Canonical Drive state → color (design spec + mock v2). */
export const DRIVE_STATE_COLOR_TOKENS: Record<string, string> = {
  identified: '#B4B2A9',
  defined: '#85B7EB',
  created: '#378ADD',
  active: '#639922',
  posted: '#0F6E56',
  drafted: '#85B7EB',
  closed: '#64748b',
};

const LIFE_ALIASES: Record<DriveLifecycle, keyof typeof DRIVE_STATE_COLOR_TOKENS> = {
  created: 'created',
  drafted: 'drafted',
  active: 'active',
  closed: 'closed',
};

export function driveLifeColor(
  life: DriveLifecycle,
  tokens: Record<string, string> = DRIVE_STATE_COLOR_TOKENS
): string {
  const key = LIFE_ALIASES[life] ?? 'identified';
  return tokens[key] ?? tokens.identified ?? '#94a3b8';
}

export function driveDetailLevelLabel(level: 'summary' | 'token' | 'card'): string {
  if (level === 'card') return 'Detailed';
  return level.charAt(0).toUpperCase() + level.slice(1);
}

export function manifestDetailLevel(value?: string | null): 'summary' | 'token' | 'card' {
  if (value === 'summary' || value === 'token') return value;
  if (value === 'detailed' || value === 'card') return 'card';
  return 'token';
}
